/* eslint-disable import/prefer-default-export */
const inspection = {
  department: 'inspection',
  departmentTitle: 'Inspection',
  object_plural: 'inspections',
};

const housekeeping = {
  department: 'cleaning',
  departmentTitle: 'Cleaning',
  object_plural: 'cleanings',
};

const maintenance = {
  department: 'maintenance',
  departmentTitle: 'Maintenance',
  object_plural: 'maintenance',
};

const task = {
  department: 'task',
  departmentTitle: 'Task',
  object_plural: 'tasks',
};

export const objects = {
  housekeeping,
  inspection,
  maintenance,
  task,
};
